module.exports = __webpack_public_path__ + "static/media/ls-mac-app-copy.2a8ebe67.svg";